<template>
  <form @submit.prevent="submitForm">
    <vs-row class="mb-4">
      <vs-col
        :vs-w="3"
        v-if="
          canReadAllBrokers ||
          !(this.currentUser && this.currentUser.id_regional)
        "
      >
        <label for="broker-select" class="block text-gray-700">
          Selecione uma Corretora:
        </label>
        <v-select
          v-model="selectedBroker"
          :options="brokers"
          label="label"
          :reduce="(broker) => broker.id"
          placeholder="Escolha a corretora"
          class="mt-2 w-full"
          clearable
          :class="{ 'is-invalid': errors.selectedBroker }"
          required
        ></v-select>
        <span v-if="errors.selectedBroker" class="text-red-500 text-sm">{{
          errors.selectedBroker
        }}</span>
      </vs-col>

      <vs-col :vs-w="3">
        <label for="start-date" class="block text-gray-700">
          Data inicial:
        </label>
        <vs-input
          id="start-date"
          type="date"
          v-model="startDate"
          class="mt-2 w-full"
          :class="{ 'is-invalid': errors.startDate }"
          required
        ></vs-input>
        <span v-if="errors.startDate" class="text-red-500 text-sm">{{
          errors.startDate
        }}</span>
      </vs-col>

      <vs-col :vs-w="3">
        <label for="end-date" class="block text-gray-700"> Data final: </label>
        <vs-input
          id="end-date"
          type="date"
          v-model="endDate"
          class="mt-2 w-full"
          :class="{ 'is-invalid': errors.endDate }"
          required
        ></vs-input>
        <span v-if="errors.endDate" class="text-red-500 text-sm">{{
          errors.endDate
        }}</span>
      </vs-col>

      <vs-col :vs-w="3">
        <vs-button type="filled" class="w-full mt-6">
          Gerar Relatório
        </vs-button>
      </vs-col>
    </vs-row>
  </form>
</template>

<script>
import vSelect from 'vue-select';
import autoApi from '../../services/auto.api';
import jwt from 'jsonwebtoken';

export default {
  name: 'BrokerCommissionFilter',
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      brokers: [],
      selectedBroker: null,
      startDate: null,
      endDate: null,
      currentUser: null,
      canReadAllBrokers: this.$can('Leitura Completa', 'Comissão'),
      errors: {},
      today: new Date().toISOString().split('T')[0],
    };
  },
  async mounted() {
    this.getDecoded();

    if (this.canReadAllBrokers) {
      await this.getBrokersList();
      return;
    }

    if (this.currentUser && this.currentUser.id_regional) {
      return (this.selectedBroker = this.currentUser.id_regional);
    }

    await this.getBrokersByUser();
  },
  methods: {
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.currentUser = jwt.decode(token);
      }
    },
    validateForm() {
      return true;
      this.errors = {};
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (!this.selectedBroker) {
        this.errors.selectedBroker = 'Selecione uma corretora.';
      }

      if (!this.startDate) {
        this.errors.startDate = 'Data inicial é obrigatória.';
      } else {
        const start = new Date(this.startDate);
        if (start >= today) {
          this.errors.startDate = 'Data inicial deve ser anterior a hoje.';
        }
      }

      if (!this.endDate) {
        this.errors.endDate = 'Data final é obrigatória.';
      } else {
        const end = new Date(this.endDate);
        if (end >= today) {
          this.errors.endDate = 'Data final deve ser anterior a hoje.';
        }
      }

      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);

        if (start > end) {
          this.errors.startDate =
            'Data inicial deve ser menor ou igual à data final.';
          this.errors.endDate =
            'Data final deve ser maior ou igual à data inicial.';
        }

        const differenceInDays = (end - start) / (1000 * 60 * 60 * 24);
        if (differenceInDays > 31) {
          this.errors.endDate =
            'O período total não pode ser maior que 31 dias.';
        }
      }

      return Object.keys(this.errors).length === 0;
    },
    submitForm() {
      if (this.validateForm()) {
        this.$emit('submitFilters', {
          brokerId: this.selectedBroker,
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
    getBrokersList() {
      autoApi
        .getBrokersList()
        .then((res) => {
          this.brokers = res;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as corretoras',
            color: 'danger',
          });
        });
    },
    getBrokersByUser() {
      autoApi
        .getBrokersByUser()
        .then((res) => {
          this.brokers = res;
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as corretoras',
            color: 'danger',
          });
        });
    },
  },
};
</script>

<style scoped>
.is-invalid {
  border: 1px solid #e3342f !important;
  background-color: #fdecea !important;
}

.text-red-500 {
  color: #e3342f;
}
</style>
